import { useToast } from '@lifebit-ai/lds'
import { UseMutationOptions, useMutation, useQueryClient } from '@tanstack/react-query'

import { invalidateRequestActivityQueries } from 'services/request-activity/invalidateRequestActivityQueries'
import { bulkUnassignExportRequests } from 'services/results'
import type { BulkUnassignExportRequestsParams, BulkUnassignExportRequestsResponse } from 'services/results/types'
import type { ApiErrorResponse } from 'services/types'

export const useBulkUnassignExportRequests = (
  options?: UseMutationOptions<BulkUnassignExportRequestsResponse, ApiErrorResponse, BulkUnassignExportRequestsParams>
) => {
  const toast = useToast()
  const queryClient = useQueryClient()

  return useMutation<BulkUnassignExportRequestsResponse, ApiErrorResponse, BulkUnassignExportRequestsParams>({
    mutationFn: params => bulkUnassignExportRequests(params),
    onError: () => {
      toast({ message: 'Failed to unassign export requests', type: 'error' })
    },
    ...options,
    onSuccess: (data, variables, onMutateResult, context) => {
      invalidateRequestActivityQueries(queryClient)
      options?.onSuccess?.(data, variables, onMutateResult, context)
    }
  })
}
